import * as React from "react";
import { Link } from "react-router-dom";

// Types
import Question from "../../types/Question.interface";

// Misc.
import { useBaseState } from "../../context/Base.context";
import IconCheckmark from "../Icons/IconCheckmark";

interface QuestionOverview {
  questions: Question[];
  parentUrl: string;
  className?: string;
  title: string;
}

const QuestionOverview: React.FC<QuestionOverview> = (
  props: QuestionOverview
) => {
  const { questions, parentUrl, className, title } = props;
  const baseState = useBaseState();

  return (
    <div className={`py-4 ${className || ""}`}>
      <div className="container mx-auto">
        <div className="w-11/12 mx-auto">
          <p className="text-dw-grey-13 font-bold uppercase tracking-wider mb-4 md:text-18 lg:text-20">
            {title}
          </p>
          <div className="grid gap-4 md:grid-cols-2">
            {questions.map((question, index) => {
              const isQuestionDone =
                Object.keys(baseState).indexOf(question._id) >= 0;

              const firstItem = index === 0;

              return (
                <div
                  key={question._id}
                  className={`${firstItem ? "md:col-span-2 lg:col-auto" : ""}`}
                >
                  <Link
                    to={`${parentUrl}/q/${question._id}`}
                    className="block font-semibold text-l text-dw-grey-14 font-serif"
                  >
                    {question.question}
                  </Link>
                  <p className="mt-2 text-dw-grey-11">
                    {isQuestionDone ? (
                      <span className="flex items-center">
                        <IconCheckmark
                          className="w-2 mr-1 h-auto"
                          color="#5c666e"
                        />
                        All tasks completed
                      </span>
                    ) : (
                      <span>0 tasks completed</span>
                    )}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuestionOverview;
